import { redirect } from "@tanstack/react-router";
import { authApi } from "../api/auth.api";

export async function requireAuth() {
  const cognitoUser = await authApi.getCurrentUser();

  if (!cognitoUser) {
    throw redirect({
      to: "/sign-in",
      search: {
        redirect: window.location.pathname,
      },
    });
  }
}

export async function requireEmailVerified() {
  try {
    const attributes = await authApi.getUserAttributes();

    if (attributes?.email_verified !== "true") {
      throw redirect({
        to: "/email-verification",
      });
    }
  } catch {
    throw redirect({
      to: "/email-verification",
    });
  }
}

export async function requireGuest(ctx: { search?: Record<string, unknown> }) {
  const cognitoUser = await authApi.getCurrentUser();

  if (cognitoUser) {
    const redirectTo =
      typeof ctx.search?.redirect === "string" ? ctx.search.redirect : "/";
    throw redirect({
      to: redirectTo,
    });
  }
}
